<div
  class="zt-carousel-viewport zt-carousel-viewport--overlay-nav featured-products-inner__carousel"
  [class.zt-carousel-viewport--static]="!showNav"
  role="region"
  [attr.aria-label]="ariaLabel || ('carousel.scroll_products' | t)">
  <button *ngIf="showNav" type="button" class="zt-carousel-viewport__nav zt-arrow-btn zt-arrow-btn--carousel"
    (click)="scrollRail($event, 'prev')" [attr.aria-label]="'common.scroll_previous' | t">
    <img [src]="chevronLeftIcon" alt="" width="24" height="24" />
  </button>
  <div class="zt-product-rail-scroll" appAutoScroll appAutoScrollItem=".product-card"
    [appAutoScrollStepRatio]="0.4" [appAutoScrollDisabled]="!autoScroll">
    <div class="product-carousel product-carousel--featured">
      <app-product-card *ngFor="let product of products; trackBy: trackById; let i = index" [product]="product"
        [priorityImage]="false"
        [forceNew]="forceNew"
        [recentlyAdded]="isRecentlyAdded(product.id)" (addToCart)="addToCart.emit($event)"
        (buyNow)="buyNow.emit($event)"
        (quickPreview)="quickPreview.emit($event)" />
    </div>
  </div>
  <button *ngIf="showNav" type="button" class="zt-carousel-viewport__nav zt-arrow-btn zt-arrow-btn--carousel"
    (click)="scrollRail($event, 'next')" [attr.aria-label]="'common.scroll_next' | t">
    <img [src]="chevronRightIcon" alt="" width="24" height="24" />
  </button>
</div>